import { addressDefaultSortConfigs, } from '../constants/sort';
export const generateSortByOptions = (sortByLabel, options) => {
    return Object.assign(Object.assign({}, addressDefaultSortConfigs[sortByLabel]), (options || {}));
};
